module.exports = __webpack_public_path__ + "img/70.5d73bb67.jpg";